/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { CreateStageRequest } from '../models/create-stage-request';
import { GenericResponse } from '../models/generic-response';
import { GetStagesResponse } from '../models/get-stages-response';
import { StageResponse } from '../models/stage-response';
import { UpdateStageRequest } from '../models/update-stage-request';

/**
 * stage apis
 */
@Injectable({ providedIn: 'root' })
export class StageService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getStages()` */
  static readonly GetStagesPath = '/api/v1/stages';

  /**
   * get all stages.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getStages()` instead.
   *
   * This method doesn't expect any request body.
   */
  getStages$Response(
    params?: {
      /**
       * the page number.
       */
      page?: number;

      /**
       * the size of a page
       */
      size?: number;

      /**
       * sort
       */
      sort?: string;

      /**
       * This adds a filter to the stage list
       *  - name
       *  - description
       */
      search?: string;

      /**
       * This adds a filtering stage by admin id
       */
      adminId?: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<GetStagesResponse>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      StageService.GetStagesPath,
      'get'
    );
    if (params) {
      rb.query('page', params.page, {});
      rb.query('size', params.size, {});
      rb.query('sort', params.sort, {});
      rb.query('search', params.search, {});
      rb.query('adminId', params.adminId, {});
    }

    return this.http
      .request(
        rb.build({ responseType: 'json', accept: 'application/json', context })
      )
      .pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<GetStagesResponse>;
        })
      );
  }

  /**
   * get all stages.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getStages$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getStages(
    params?: {
      /**
       * the page number.
       */
      page?: number;

      /**
       * the size of a page
       */
      size?: number;

      /**
       * sort
       */
      sort?: string;

      /**
       * This adds a filter to the stage list
       *  - name
       *  - description
       */
      search?: string;

      /**
       * This adds a filtering stage by admin id
       */
      adminId?: number;
    },
    context?: HttpContext
  ): Observable<GetStagesResponse> {
    return this.getStages$Response(params, context).pipe(
      map(
        (r: StrictHttpResponse<GetStagesResponse>): GetStagesResponse => r.body
      )
    );
  }

  /** Path part for operation `createStage()` */
  static readonly CreateStagePath = '/api/v1/stages';

  /**
   * create new Stage.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createStage()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createStage$Response(
    params: {
      body: CreateStageRequest;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<StageResponse>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      StageService.CreateStagePath,
      'post'
    );
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http
      .request(
        rb.build({ responseType: 'json', accept: 'application/json', context })
      )
      .pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<StageResponse>;
        })
      );
  }

  /**
   * create new Stage.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createStage$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createStage(
    params: {
      body: CreateStageRequest;
    },
    context?: HttpContext
  ): Observable<StageResponse> {
    return this.createStage$Response(params, context).pipe(
      map((r: StrictHttpResponse<StageResponse>): StageResponse => r.body)
    );
  }

  /** Path part for operation `getStageById()` */
  static readonly GetStageByIdPath = '/api/v1/stages/{id}';

  /**
   * get stage by id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getStageById()` instead.
   *
   * This method doesn't expect any request body.
   */
  getStageById$Response(
    params: {
      /**
       * The stage id that needs to be fetched
       */
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<StageResponse>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      StageService.GetStageByIdPath,
      'get'
    );
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http
      .request(
        rb.build({ responseType: 'json', accept: 'application/json', context })
      )
      .pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<StageResponse>;
        })
      );
  }

  /**
   * get stage by id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getStageById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getStageById(
    params: {
      /**
       * The stage id that needs to be fetched
       */
      id: number;
    },
    context?: HttpContext
  ): Observable<StageResponse> {
    return this.getStageById$Response(params, context).pipe(
      map((r: StrictHttpResponse<StageResponse>): StageResponse => r.body)
    );
  }

  /** Path part for operation `disableStageById()` */
  static readonly DisableStageByIdPath = '/api/v1/stages/{id}';

  /**
   * disable stage by id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `disableStageById()` instead.
   *
   * This method doesn't expect any request body.
   */
  disableStageById$Response(
    params: {
      /**
       * The stage id that needs to be soft deleted
       */
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<GenericResponse>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      StageService.DisableStageByIdPath,
      'delete'
    );
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http
      .request(
        rb.build({ responseType: 'json', accept: 'application/json', context })
      )
      .pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<GenericResponse>;
        })
      );
  }

  /**
   * disable stage by id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `disableStageById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  disableStageById(
    params: {
      /**
       * The stage id that needs to be soft deleted
       */
      id: number;
    },
    context?: HttpContext
  ): Observable<GenericResponse> {
    return this.disableStageById$Response(params, context).pipe(
      map((r: StrictHttpResponse<GenericResponse>): GenericResponse => r.body)
    );
  }

  /** Path part for operation `updateStageById()` */
  static readonly UpdateStageByIdPath = '/api/v1/stages/{id}';

  /**
   * update stage by id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateStageById()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateStageById$Response(
    params: {
      /**
       * The stage id that needs to be updated
       */
      id: number;
      body: UpdateStageRequest;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<StageResponse>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      StageService.UpdateStageByIdPath,
      'patch'
    );
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http
      .request(
        rb.build({ responseType: 'json', accept: 'application/json', context })
      )
      .pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<StageResponse>;
        })
      );
  }

  /**
   * update stage by id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateStageById$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateStageById(
    params: {
      /**
       * The stage id that needs to be updated
       */
      id: number;
      body: UpdateStageRequest;
    },
    context?: HttpContext
  ): Observable<StageResponse> {
    return this.updateStageById$Response(params, context).pipe(
      map((r: StrictHttpResponse<StageResponse>): StageResponse => r.body)
    );
  }
}
